import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { setLastUrl } from '../store/navigationStore';

export function useRouteTracking() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const prevUrlRef = useRef<string | null>(null);

  useEffect(() => {
    const currentUrl = location.pathname + location.search;
    const isIgnored = ['/login', '/forgot-password', '/reset-password', '/'].includes(location.pathname) || location.pathname.startsWith('/spaces') === false;

    if (prevUrlRef.current && prevUrlRef.current !== currentUrl && !isIgnored && navigationType !== 'REPLACE') {
      setLastUrl(prevUrlRef.current);
    }

    if (!isIgnored) {
      prevUrlRef.current = currentUrl;
    }
  }, [location, navigationType]);
}
